import FlexColumn from "./FlexColumn";
import FlexRow from "./FlexRow";

import { MutableRefObject } from "react";
import { ReactElement, ReactNode } from "react";

type Props = Readonly<{
    direction?: "row" | "column";
    children?: ReactNode;
    alignment?: "start" | "center" | "end";
    width?: "full" | "half" | "quarter" | "auto" | string | number;
    style?: React.CSSProperties | undefined;
    className?: string;
    onClick?: (event?: React.MouseEvent) => void;
    onBlur?: () => void;
    gap?: 4 | 8 | 12 | 16;
    wrap?: boolean;
    forwardRef?: MutableRefObject<any>;
}>;

export default function Flexbox({
    direction = "column",
    ...props
}: Props): ReactElement {
    return (
        <>
            {direction === "column" ? (
                <FlexColumn {...props}>{props.children}</FlexColumn>
            ) : (
                <FlexRow {...props}>{props.children}</FlexRow>
            )}
        </>
    );
}
